<template>
    <div class="members">
        <div class="members__container">
            <h2>Members of</h2>
            
            <el-carousel arrow="always" height="140px" trigger="click" indicator-position="none" :autoplay="true" v-if="$mq.resize && $mq.below('474px')">
                <el-carousel-item class="members__list" v-for="i in Math.ceil(members.length / 2)" v-bind:key="i">
                    <members-item v-for="member in members.slice((i - 1) * 2, i * 2)" v-bind:key="member.id" :member="member" ></members-item>
                </el-carousel-item>
            </el-carousel>
            
            <el-carousel arrow="always" height="140px" trigger="click" indicator-position="none" :autoplay="true" v-if="$mq.resize && $mq.above('475px') && $mq.below('739px')">
                <el-carousel-item class="members__list" v-for="i in Math.ceil(members.length / 3)" v-bind:key="i">
                    <members-item v-for="member in members.slice((i - 1) * 3, i * 3)" v-bind:key="member.id" :member="member" ></members-item>
                </el-carousel-item>
            </el-carousel>
            
            <el-carousel arrow="always" height="140px" trigger="click" indicator-position="none" :autoplay="true" v-if="$mq.resize && $mq.above('740px') && $mq.below('1023px')">
                <el-carousel-item class="members__list" v-for="i in Math.ceil(members.length / 5)" v-bind:key="i">
                    <members-item v-for="member in members.slice((i - 1) * 5, i * 5)" v-bind:key="member.id" :member="member" ></members-item>
                </el-carousel-item>
            </el-carousel>
            
            <div class="members__list" v-if="$mq.resize && $mq.above('1024px')">
                <members-item v-for="member in members" :key="member.id" :member="member"></members-item>
            </div>
            
        </div>
    </div>
</template>
<script>
import MembersItem from './Item.vue'

export default {
    
    name: 'members-list',
    
    data: function() {
        return {
            loading: false,
            members: {},
        };
    },
    
    props: {
        url: String,
    },
    
    created: function() {
        if (typeof this.url === 'undefined') return;
        
        this.loading = true;
        
        this.$http.get(this.url).then(function(response) {
            this.members = response.data.data;
            this.members.sort(function(a,b) { return (a.title > b.title) ? 1 : ((b.title > a.title) ? -1 : 0); });
            this.loading = false; 
        });
    },
    
    methods: {
    },
    
    components: {
        'members-item': MembersItem,
    }
}
</script>


// WEBPACK FOOTER //
// List.vue?7af8c17b